/**
 * MACRO #26 · Increment 3 — public Explore discovery client.
 *
 * Reads ONLY the certified publication authority: a bounded, deterministic list
 * of CURRENT valid public territories (never Draft / withdrawn / stale). No
 * wallet required. No fabricated metrics — the server orders by real
 * `published_at` (Recently Published), and every card is a truthful public
 * snapshot summary.
 */
import { API_BASE } from "./api";

export interface ExploreTerritory {
  identity_id: string;
  display_name: string | null;
  published_at: string | null;
  module_count: number;
  has_3d: boolean;
  has_media: boolean;
}

export async function listExploreTerritories(limit = 24, signal?: AbortSignal): Promise<ExploreTerritory[]> {
  const resp = await fetch(`${API_BASE}/api/v1/publications/explore?limit=${encodeURIComponent(String(limit))}`, {
    cache: "no-store",
    signal,
  });
  if (!resp.ok) throw new Error(`explore_failed_${resp.status}`);
  const body = (await resp.json()) as { territories?: ExploreTerritory[] };
  return body.territories ?? [];
}
